import ImmunefiSVG from "../assets/security/immunefi.svg";
import QuantstampSVG from "../assets/security/quantstamp.svg";
import OpenZeppelinSVG from "../assets/security/open-zeppelin.svg";
import styles from "./Security.module.scss";
import SecuritySVG from "../assets/security/security.svg";

export const Security = () => {
  return (
    <div className={styles.security}>
      <div className={styles.background} />
      <div className={styles.container}>
        <div className={styles.title}>
          <img src={SecuritySVG} alt="Security" height="75px" />
          <div>
            <h2>
              <span className={`gradient ${styles.bold}`}>Battle - tested</span>{" "}
              security
            </h2>
          </div>
        </div>
        <div className={styles.logos}>
          <div>
            <img src={ImmunefiSVG} alt="immunefi" />
            <a
              className={styles.bounty}
              href="https://immunefi.com/bug-bounty/hashflow/information/"
              target="_blank"
              rel="noreferrer"
              role="button"
            >
              Bug bounty
            </a>
          </div>
          <img src={QuantstampSVG} alt="quantstamp" />
          <img src={OpenZeppelinSVG} alt="openzeppelin" />
        </div>
      </div>
    </div>
  );
};
